export default {
  // 模块名称
  video: {
    // 按钮类
    button: {
      reset: 'Reset',
      confirm: 'Confirm',
      cancel: 'Cancel',
      add: 'add',
      cover: 'cover',
      delete: 'delete',
      edit: 'edit',
      drag: 'drag',
      addMonitor: 'Add monitor',
      manualVideo: 'Manual video',
      planVideo: 'Plan video',
      warnVideo: 'Warn video',
      Search: 'Query'
    },
    // 文字标签类
    label: {
      favorites: 'favorites',
      timesSpeed: 'speed',
      number: 'No',
      selectDate: 'SelectDate',
      startTime: 'StartTime',
      endTime: 'EndTime',
      HoldingInter: 'Keep time',
      storageLocation: 'Location',
      server: 'Server',
      front: 'Front ',
      halfHour: 'Half an hour',
      oneHour: 'One hour',
      fourHour: 'Four hours',
      twlHour: '12 hours',
      dobHour: '24 hours',
      thrDay: '3 days',
      oneWeek: 'One week',
      muchday: '30 days',
      camerName: 'Camera name',
      videoStart: 'Start time',
      videoEnd: 'End time',
      operation: 'Operation',
      progress: 'progress',
      status: 'Status',
      speed: 'Speed',
      lastTime: 'Time',
      loadPath: 'Download path',
      uploadTime: 'Select download time',
      anyTime: 'Any time',
      whetherAcross: 'Whether cross-day',
      yes: 'Yes',
      no: 'No',
      download: 'download',
      finish: 'completed',
      downSucc: 'Video download completed',
      showScene: 'Show save scene',
      init: 'initializing...',
      pleaseDown:
        'The ActiveX OCX control is not detected. Please download first.',
      clickBtn: 'Click on the download',
      supportIe: 'Sorry, the current control only supports IE browser.',
      getVideo: 'Getting video information...',
      fullScreen: 'Full',
      playVideo: 'play',
      capture: 'capture',
      a: 'Entries',
      addFavorite: 'Favorites',
      selected: 'Selected',
      addFavoritea: 'Favoritea',
      isAdd: 'Already joined',
      newAdd: 'New favorites',
      reduceScale: 'Reduce scale',
      enlargeScale: 'Enlarge scale',
      windows: 'Window',
      hours: 'Hour',
      msgInfo1: 'The download time range cannot be less than 1 second',
      list: 'No favorites, please create if needed',
      loading: 'Loading...'
    },
    // 提示类
    placeholder: {
      selectStartTime: 'Please select start time',
      selectEndTime: 'Please select end time',
      selectKeepTime: 'Please select an interval',
      selectKeepLoca: 'Storage location',
      selectVideoType: 'Please select video type',
      compareEndTime: 'Start time cannot be greater than end time',
      selectTimeLen: 'Video time range cannot exceed 30 days',
      addOrSeachFavorite: 'Search or create favorites',
      name: 'Please enter name',
      pleaseSelect: 'please choose'
    },
    // 消息类
    message: {
      deleteWarn: 'Are you sure to delete the current preset?',
      disableEmpty: 'Preset name cannot be empty',
      disableInclude: 'Task name cannot contain special characters',
      disableMore: 'The preset name cannot exceed 20 characters!',
      coverWarn: 'Do you want to confirm the current scene?',
      deleteSceneWarn: 'Are you sure to delete the current scene?',
      deleteOk: 'Successfully deleted',
      disableNameEmpty: 'Scene name cannot be empty',
      disableNameMore: 'The scene name cannot exceed 20 characters!',
      deleteNameWarn: 'Are you sure to delete the currently selected node?',
      disableFlodEmpty: 'Folder name cannot be empty',
      disableFlodMore: 'The folder name cannot exceed 50 characters!',
      disableFlodReg: 'The folder name can only input chinese,letter or number!',
      canOperate: 'Only ball machine or holder gun can operate holder control!',
      canAddOperate: 'Only the dome can add presets!',
      selectCamera: 'Please select the camera device first.',
      selectWindow: 'Please select the window first.',
      chooseCamera: 'Most choice 4 cameras',
      addOk: 'added successfully',
      coverOk: 'Successful coverage',
      noSearchCamer: 'No video of camera {deviceName} was retrieved',
      video: 'Video!',
      noSearchVideo: 'No video was retrieved!',
      cancelOk: 'Cancel success',
      videoStart: 'Video has been started',
      camer: 'camera',
      pleaseStop: 'Recording has started, please stop first!',
      startvideoS: 'Please start recording',
      pleaseStart: 'Video has not started yet, please start!',
      noVideo: 'No signal source!',
      setOk: 'The monitoring point was successfully set up',
      laterTry: 'The last action is not complete, please try again later!',
      deviceNo: 'The device is not online!',
      newSucc: 'Created successfully'
    },
    // 标题类
    title: {
      cameraList: 'Camera list',
      favorites: 'Favorites',
      camera: 'camera',
      yuntaiControl: 'Yuntai control',
      scopeLarge: 'scope bigger',
      scopeSmalle: 'scope smaller',
      apertureSmalle: 'aperture smaller',
      apertureLarge: 'aperture bigger',
      focusNearly: 'focusNearly',
      focusFar: 'focusFar',
      setPreset: 'Set preset',
      searchPreset: 'search',
      addPreset: 'Add preset',
      delPreset: 'delete',
      callPreset: 'call',
      call: 'call',
      presetName: 'Preset name',
      fullScreen: 'fullscreen',
      video: 'video',
      stopVideo: 'stopVideo',
      localSnap: 'local snap',
      snapList: 'Snap list',
      platSnap: 'plat snap',
      stop: 'stop',
      oneScreen: 'one screen',
      fourScreen: 'four screen',
      nineScreen: 'nine screen',
      sceneCollect: 'Scene collection',
      sceneName: 'Scene name',
      addScene: 'Add scene',
      coverScene: 'Cover scene',
      delScene: 'Delete scene',
      cameraCollect: 'Camera collection',
      newfolder: 'New folder',
      newfolderName: 'New Name',
      delFavFolder: 'Delete folder favorites',
      videoSearch: 'Video search',
      videoUpload: 'Video download',
      selectedCamera: 'Selected',
      back: 'back',
      play: 'play',
      fast: 'fast',
      stopPlay: 'pause',
      switch: 'switch list'
    }
  }
}
